/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useHistory, Link } from "react-router-dom";
import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Register.css";

const Register = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false)
  const [state, setState] = useState({
    username: "",
    password: "",
    confirmPassword: ""
  })
  const postURL = config.endpoint + `/auth/register`
  const handleChange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  }
  const history = useHistory()

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement the register function
  /**
   * Definition for register handler
   * - Function to be called when the user clicks on the register button or submits the register form
   *
   * @param {{ username: string, password: string, confirmPassword: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/register"
   *
   * Example for successful response from backend for the API call:
   * HTTP 201
   * {
   *      "success": true,
   * }
   *
   * Example for failed response from backend for the API call:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Username is already taken"
   * }
   */
  
  let message
  const register = async (e) => {    
    e.preventDefault()
    const formData = { username: state.username, password: state.password }
    // console.log(formData)
    if(validateInput(state)){
      try {
        setLoading(true)
        await axios.post(postURL, formData)
          .then(() => {
            message = "Registered successfully"
            enqueueSnackbar(message, {variant: 'success'})
            setLoading(false)
            history.push("/login")
          })
          .catch(formData => {
            message = formData.response.data.message
            enqueueSnackbar(message, {variant: 'error'})
            setLoading(false)
          })
      } catch (error) {
          message = "Something went wrong. Check that the backend is running, reachable and returns valid JSON."
          enqueueSnackbar(message, {variant: 'error'})
          setLoading(false)
      }
    }
  } 

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement user input validation logic
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string, confirmPassword: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that username field is not less than 6 characters in length - "Username must be at least 6 characters"
   * -    Check that password field is not an empty value - "Password is a required field"
   * -    Check that password field is not less than 6 characters in length - "Password must be at least 6 characters"
   * -    Check that confirmPassword field has the same value as password field - Passwords do not match
   */
  const validateInput = (data) => {
    if (data.username === "") {
      message = "Username is a required field"
      enqueueSnackbar(message, {variant: 'warning'})
      return false
    }else if(data.username.length < 6){
      message = "Username must be at least 6 characters"
      enqueueSnackbar(message, {variant: 'warning'})
      return false
    }else if(data.password === ""){
	    message = "Password is a required field"
	    enqueueSnackbar(message, {variant: 'warning'})
      return false
	  }else if(data.password.length < 6){
	    message = "Password must be at least 6 characters"
	    enqueueSnackbar(message, {variant: 'warning'})
      return false
    }else if(data.password !== data.confirmPassword){
      message = "Passwords do not match"
	    enqueueSnackbar(message, {variant: 'warning'})
      return false
    }
      return true
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons />
      <Box className="content" >
        <Stack spacing={2} className="form" >
          <h2 className="title">Register</h2>
          <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            name="username"
            placeholder="Enter Username"
            fullWidth
            onChange={handleChange}
          />

          <TextField
            id="password"
            variant="outlined"
            label="Password"
            name="password"
            type="password"
            helperText="Password must be atleast 6 characters length"
            fullWidth
            placeholder="Enter a password with minimum 6 characters"
            onChange={handleChange}
          />

          <TextField
            id="confirmPassword"
            variant="outlined"
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            fullWidth
            onChange={handleChange}
          />

            {loading ? (
            <CircularProgress color="success" style={{alignSelf: "center"}} />
            ) : (
            <Button className="button" variant="contained" onClick={register}> Register Now </Button>
            )}
          <p className="secondary-action">
            Already have an account?{" "}
             <Link className="link" to="/login">
              Login here
             </Link> 
          </p>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );

}

export default Register;
